import { render, staticRenderFns } from "./OxygenFocusPointInput.vue?vue&type=template&id=6cb3578b&"
import script from "./OxygenFocusPointInput.vue?vue&type=script&lang=ts&"
export * from "./OxygenFocusPointInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports